import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ed9098a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "nge-chat-strip-label"
}
const _hoisted_3 = {
  key: 1,
  class: "nge-chat-online-wrap"
}
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-chat-online-dot",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-chat-online-who" }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 2,
  class: "nge-chat-strip-unread",
  title: "New messages"
}
const _hoisted_10 = {
  key: 3,
  class: "nge-chat-mentioned-by"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-strip-spacer" }, null, -1 /* HOISTED */))
const _hoisted_12 = ["aria-pressed", "title"]
const _hoisted_13 = ["onClick", "aria-pressed", "title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "7"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "21",
    y1: "21",
    x2: "16.2",
    y2: "16.2"
  })
], -1 /* HOISTED */))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" }, null, -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" }, null, -1 /* HOISTED */))
const _hoisted_20 = {
  key: 0,
  x1: "3",
  y1: "3",
  x2: "21",
  y2: "21"
}
const _hoisted_21 = ["onClick", "title"]
const _hoisted_22 = {
  key: 0,
  class: "nge-chat-pin",
  role: "note"
}
const _hoisted_23 = ["title"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-chat-pin-glyph",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-chat-pin-ico",
    viewBox: "0 0 16 16",
    width: "12",
    height: "12",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.7 1.7 14.3 6.3M10.7 2.7 7 6.4 4 7l5 5 .6-3 3.7-3.7M6.4 9.6 2.2 13.8" })
  ])
], -1 /* HOISTED */))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "nge-chat-messages-wrap" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-chat-fade" }, null, -1 /* HOISTED */))
const _hoisted_29 = { class: "nge-chat-tips-head" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Chat tips", -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "@name"),
    /*#__PURE__*/_createTextVNode(" mentions someone and lets them know.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "#"),
    /*#__PURE__*/_createTextVNode(" and a cell ID, like "),
    /*#__PURE__*/_createElementVNode("code", null, "#864691135012345678"),
    /*#__PURE__*/_createTextVNode(", makes a link that opens the cell.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "/me waves"),
    /*#__PURE__*/_createTextVNode(" shows a grey line, like "),
    /*#__PURE__*/_createElementVNode("i", null, "Nseraf waves"),
    /*#__PURE__*/_createTextVNode(".")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("code", null, "*bold*"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("code", null, "_underline_"),
    /*#__PURE__*/_createTextVNode(". Shift+Enter for a new line.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Point at a message to react (the Pyr gem too) or reply with ↩."),
  /*#__PURE__*/_createElementVNode("li", null, "A pinned message from the team sits at the top. Click it to jump there, or × to hide it."),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("🔍 searches. Try "),
    /*#__PURE__*/_createElementVNode("code", null, "from:name"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "on:10/8"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "-word"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "\"two words\""),
    /*#__PURE__*/_createTextVNode(".")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "The bell sends notifications while Pyr is in the background. To hide the unread count, use Settings, Mute the chat unread count."),
  /*#__PURE__*/_createElementVNode("li", null, "📍 shares your view, with a screenshot if you like. 🙂 adds an emoji."),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Ask Nurro with "),
    /*#__PURE__*/_createElementVNode("code", null, "!"),
    /*#__PURE__*/_createTextVNode(": "),
    /*#__PURE__*/_createElementVNode("code", null, "!faq"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "!cut"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "!merge"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("code", null, "!online"),
    /*#__PURE__*/_createTextVNode(". "),
    /*#__PURE__*/_createElementVNode("code", null, "!help"),
    /*#__PURE__*/_createTextVNode(" lists them all. Only you see the answer.")
  ])
], -1 /* HOISTED */))
const _hoisted_32 = { class: "nge-chat-messages-inner" }
const _hoisted_33 = {
  key: 0,
  class: "nge-chat-history-top"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 1,
  class: "nge-chat-search-note",
  role: "status"
}
const _hoisted_37 = {
  key: 0,
  class: "nge-chat-new-line",
  role: "separator"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "New since you left", -1 /* HOISTED */))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "nge-chat-time-sep"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-chat-pin-ico",
  viewBox: "0 0 16 16",
  width: "12",
  height: "12",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.7 1.7 14.3 6.3M10.7 2.7 7 6.4 4 7l5 5 .6-3 3.7-3.7M6.4 9.6 2.2 13.8" })
], -1 /* HOISTED */))
const _hoisted_42 = ["title", "onClick", "onKeydown"]
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  key: 1,
  class: "nge-chat-ach-star",
  "aria-hidden": "true"
}
const _hoisted_45 = { class: "nge-chat-ach-name" }
const _hoisted_46 = { class: "nge-chat-ach-why" }
const _hoisted_47 = ["data-msg-id"]
const _hoisted_48 = ["onClick", "onKeydown"]
const _hoisted_49 = {
  key: 0,
  class: "nge-chat-msg-time"
}
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 2,
  class: "nge-chat-announce-icon",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "nge-chat-announce-text" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["title", "onClick"]
const _hoisted_55 = ["src"]
const _hoisted_56 = ["aria-expanded"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-announce-cta" }, "Open →", -1 /* HOISTED */))
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["title", "disabled", "onClick"]
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "nge-chat-daily-head" }
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-daily-title" }, "Today's leaders", -1 /* HOISTED */))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-daily-sub" }, "last 24 h", -1 /* HOISTED */))
const _hoisted_65 = {
  key: 0,
  class: "nge-chat-daily-cols"
}
const _hoisted_66 = {
  key: 0,
  class: "nge-chat-daily-col"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-chat-daily-label" }, "Most edits", -1 /* HOISTED */))
const _hoisted_68 = { class: "nge-chat-daily-medal" }
const _hoisted_69 = ["onClick", "title"]
const _hoisted_70 = { class: "nge-chat-daily-n" }
const _hoisted_71 = {
  key: 1,
  class: "nge-chat-daily-col"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-chat-daily-label" }, "Most cells", -1 /* HOISTED */))
const _hoisted_73 = { class: "nge-chat-daily-medal" }
const _hoisted_74 = ["onClick", "title"]
const _hoisted_75 = { class: "nge-chat-daily-n" }
const _hoisted_76 = {
  key: 1,
  class: "nge-chat-daily-empty"
}
const _hoisted_77 = ["onClick", "data-msg-id", "title"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-chat-quote-arrow",
  "aria-hidden": "true"
}, "↩", -1 /* HOISTED */))
const _hoisted_80 = { class: "nge-chat-quote-name" }
const _hoisted_81 = { class: "nge-chat-quote-text" }
const _hoisted_82 = {
  key: 1,
  class: "nge-chat-quote nge-chat-quote--gone"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-chat-quote-arrow",
  "aria-hidden": "true"
}, "↩", -1 /* HOISTED */))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-quote-text" }, "an earlier message", -1 /* HOISTED */))
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]
const _hoisted_86 = { class: "nge-chat-msg-time" }
const _hoisted_87 = ["title"]
const _hoisted_88 = ["src"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-bot-tag nge-chat-nurro-tag" }, "guide", -1 /* HOISTED */))
const _hoisted_90 = ["title"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-bot-tag" }, "bot", -1 /* HOISTED */))
const _hoisted_92 = {
  key: 0,
  class: "nge-chat-help-lead"
}
const _hoisted_93 = ["onClick", "title"]
const _hoisted_94 = ["href"]
const _hoisted_95 = ["href"]
const _hoisted_96 = ["src"]
const _hoisted_97 = ["href"]
const _hoisted_98 = ["onClick", "onKeydown", "title"]
const _hoisted_99 = {
  key: 5,
  class: "nge-chat-seg-chip"
}
const _hoisted_100 = ["href", "onClick", "title"]
const _hoisted_101 = ["title"]
const _hoisted_102 = ["onClick", "title"]
const _hoisted_103 = {
  key: 1,
  class: "nge-chat-u"
}
const _hoisted_104 = ["disabled", "title", "onClick"]
const _hoisted_105 = {
  key: 7,
  class: "nge-chat-bot-lang"
}
const _hoisted_106 = ["title", "onClick"]
const _hoisted_107 = { class: "nge-chat-react-add" }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = ["onClick", "onContextmenu", "data-nge-own-menu", "title"]
const _hoisted_110 = ["title", "onClick"]
const _hoisted_111 = ["src"]
const _hoisted_112 = ["aria-expanded"]
const _hoisted_113 = {
  key: 2,
  class: "nge-chat-react-picker nge-chat-pin-menu",
  role: "menu"
}
const _hoisted_114 = ["disabled", "onClick"]
const _hoisted_115 = {
  key: 0,
  class: "nge-chat-react-row"
}
const _hoisted_116 = ["title", "onClick"]
const _hoisted_117 = ["src"]
const _hoisted_118 = {
  key: 2,
  class: "nge-chat-empty"
}
const _hoisted_119 = {
  key: 3,
  class: "nge-chat-empty"
}
const _hoisted_120 = {
  key: 1,
  class: "nge-chat-segwarn"
}
const _hoisted_121 = { class: "nge-chat-segwarn-text" }
const _hoisted_122 = { class: "nge-chat-segwarn-actions" }
const _hoisted_123 = { class: "nge-chat-input-wrap" }
const _hoisted_124 = {
  key: 0,
  class: "nge-chat-replying"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-chat-quote-arrow",
  "aria-hidden": "true"
}, "↩", -1 /* HOISTED */))
const _hoisted_126 = { class: "nge-chat-replying-text" }
const _hoisted_127 = { class: "nge-chat-quote-text" }
const _hoisted_128 = {
  key: 1,
  class: "nge-chat-mention-menu",
  role: "listbox"
}
const _hoisted_129 = ["onMousedown", "onMouseenter"]
const _hoisted_130 = {
  key: 2,
  class: "nge-chat-join-note",
  role: "status"
}
const _hoisted_131 = {
  key: 4,
  class: "nge-chat-pending-view"
}
const _hoisted_132 = { class: "nge-chat-view-chip nge-chat-view-chip--pending" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-pending-hint" }, "Type a message, then press Enter to send.", -1 /* HOISTED */))
const _hoisted_134 = {
  key: 5,
  class: "nge-chat-input-row nge-chat-search-row"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-chat-search-glyph",
  width: "15",
  height: "15",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "7"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "21",
    y1: "21",
    x2: "16.2",
    y2: "16.2"
  })
], -1 /* HOISTED */))
const _hoisted_136 = ["onKeydown"]
const _hoisted_137 = ["onClick"]
const _hoisted_138 = {
  key: 6,
  class: "nge-chat-input-row"
}
const _hoisted_139 = { class: "nge-chat-share" }
const _hoisted_140 = ["disabled"]
const _hoisted_141 = {
  key: 1,
  class: "nge-chat-share-pin",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "aria-hidden": "true"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 15.4S2.6 10.5 2.6 6.3a5.4 5.4 0 0 1 10.8 0C13.4 10.5 8 15.4 8 15.4zM8 8.4a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2z" }, null, -1 /* HOISTED */))
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = {
  key: 0,
  class: "nge-chat-share-menu"
}
const _hoisted_145 = ["placeholder", "onKeydown", "disabled"]
const _hoisted_146 = ["title"]
const _hoisted_147 = { class: "nge-chat-emoji" }
const _hoisted_148 = ["disabled"]
const _hoisted_149 = ["onClick"]
const _hoisted_150 = ["title", "aria-label"]
const _hoisted_151 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        ref: "panelEl",
        class: _normalizeClass(["nge-chat-float", { 'nge-chat-float--collapsed': $setup.collapsed, 'nge-chat-float--dragging': $setup.isDragging, 'nge-chat-float--mentioned': $setup.mentionFlash, 'nge-chat-float--quiet': $setup.isQuiet, 'nge-chat-float--resizing': $setup.isResizing, 'nge-chat-selecting': $setup.selectingText }]),
        onFocusin: $setup.onPanelFocusIn,
        style: _normalizeStyle({
        ...($setup.collapsed ? {} : { width: $setup.panelWidth + 'px', height: $setup.shownHeight + 'px' }),
        ...$setup.positionStyle
      })
      }, [
        _createCommentVNode(" Resize handles — edges and corner "),
        (!$setup.collapsed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nge-chat-resize nge-chat-resize--corner",
              onMousedown: _cache[0] || (_cache[0] = $event => ($setup.startResize($event, 'corner')))
            }, null, 32 /* HYDRATE_EVENTS */))
          : _createCommentVNode("v-if", true),
        (!$setup.collapsed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "nge-chat-resize nge-chat-resize--top",
              onMousedown: _cache[1] || (_cache[1] = $event => ($setup.startResize($event, 'top')))
            }, null, 32 /* HYDRATE_EVENTS */))
          : _createCommentVNode("v-if", true),
        (!$setup.collapsed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "nge-chat-resize nge-chat-resize--right",
              onMousedown: _cache[2] || (_cache[2] = $event => ($setup.startResize($event, 'right')))
            }, null, 32 /* HYDRATE_EVENTS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Tiny drag/control strip "),
        _createElementVNode("div", {
          class: "nge-chat-strip",
          onMousedown: $setup.startDrag,
          onDblclick: $setup.toggleCollapse
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["nge-chat-strip-dot", { 'nge-chat-strip-dot--on': $setup.connected, 'nge-chat-strip-dot--slow': !$setup.connected && $setup.chatStore.polling }]),
            title: $setup.connected ? 'Chat is live' : $setup.chatStore.polling ? 'Live updates are down. Chat still works: new messages are fetched every few seconds.' : 'Chat is not connected'
          }, null, 10 /* CLASS, PROPS */, _hoisted_1),
          ($setup.collapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Chat"))
            : _createCommentVNode("v-if", true),
          ($setup.chatUsable && $setup.chatStore.onlineCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createElementVNode("button", {
                  type: "button",
                  class: "nge-chat-online",
                  "aria-expanded": $setup.showOnline,
                  title: "See who is online",
                  onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.showOnline = !$setup.showOnline), ["stop"]))
                }, _toDisplayString($setup.chatStore.onlineCount) + " online", 9 /* TEXT, PROPS */, _hoisted_4),
                _createCommentVNode(" Who that is (Ames 2026-10-09). A name opens that player's profile. "),
                ($setup.showOnline)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "nge-chat-online-list",
                      role: "menu",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.onlineNow, (p) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: p.id,
                          type: "button",
                          class: "nge-chat-online-name",
                          role: "menuitem",
                          style: _normalizeStyle({ color: $setup.rankColor($setup.knownRank[p.name] || 'player') }),
                          onClick: $event => ($setup.openOnlineProfile(p.id))
                        }, [
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(p.name), 1 /* TEXT */),
                          (p.where)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "nge-chat-online-where",
                                title: 'In ' + p.where
                              }, _toDisplayString(p.where), 9 /* TEXT, PROPS */, _hoisted_8))
                            : _createCommentVNode("v-if", true)
                        ], 12 /* STYLE, PROPS */, _hoisted_5))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.collapsed && $setup.unreadMessages)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9))
            : _createCommentVNode("v-if", true),
          ($setup.mentionFlash && $setup.chatStore.lastMentionFrom)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "@ from " + _toDisplayString($setup.chatStore.lastMentionFrom), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _hoisted_11,
          _createElementVNode("button", {
            class: _normalizeClass(["nge-chat-strip-btn nge-chat-tips-btn", { 'nge-chat-tips-btn--on': $setup.tipsOpen }]),
            onClick: _cache[5] || (_cache[5] = _withModifiers($event => ($setup.tipsOpen ? ($setup.tipsOpen = false) : $setup.openTips()), ["stop"])),
            "aria-pressed": $setup.tipsOpen,
            title: $setup.tipsOpen ? 'Close chat tips' : 'Chat tips: what chat can do',
            "aria-label": "Chat tips"
          }, "?", 10 /* CLASS, PROPS */, _hoisted_12),
          ($setup.isLoggedIn)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                class: _normalizeClass(["nge-chat-strip-btn nge-chat-search-btn", { 'nge-chat-search-btn--on': $setup.searchOpen }]),
                onClick: _withModifiers($setup.toggleSearch, ["stop"]),
                "aria-pressed": $setup.searchOpen,
                title: $setup.searchOpen ? 'Close search (Esc)' : 'Search chat'
              }, _hoisted_15, 10 /* CLASS, PROPS */, _hoisted_13))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: _normalizeClass(["nge-chat-strip-btn nge-chat-bell-btn", { 'nge-chat-bell-btn--on': $setup.chatStore.mentionNotify }]),
            onClick: _cache[6] || (_cache[6] = _withModifiers($event => ($setup.chatStore.setMentionNotify(!$setup.chatStore.mentionNotify)), ["stop"])),
            title: $setup.chatStore.mentionNotify ? 'Chat notifications are on: new messages notify you while EyeWire is in the background (click to turn off)' : 'Turn on browser notifications for new chat messages while EyeWire is in the background'
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              (!$setup.chatStore.mentionNotify)
                ? (_openBlock(), _createElementBlock("line", _hoisted_20))
                : _createCommentVNode("v-if", true)
            ]))
          ], 10 /* CLASS, PROPS */, _hoisted_16),
          _createElementVNode("button", {
            class: "nge-chat-strip-btn nge-chat-collapse-btn",
            onClick: _withModifiers($setup.toggleCollapse, ["stop"]),
            title: $setup.collapsed ? 'Expand chat' : 'Collapse chat'
          }, _toDisplayString($setup.collapsed ? '▲' : '▼'), 9 /* TEXT, PROPS */, _hoisted_21),
          _createElementVNode("button", {
            class: "nge-chat-strip-btn nge-chat-close-btn",
            onClick: _cache[7] || (_cache[7] = _withModifiers($event => ($setup.emit('hide')), ["stop"])),
            title: "Close chat"
          }, "×")
        ], 32 /* HYDRATE_EVENTS */),
        _createCommentVNode(" Body (hidden when collapsed) "),
        (!$setup.collapsed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createCommentVNode(" Message area with top fade "),
              ($setup.shownPin && !$setup.searchOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-chat-pin-text",
                      title: 'Pinned by ' + $setup.shownPin.by + '. Click to go to the message.',
                      onClick: _cache[8] || (_cache[8] = _withModifiers($event => ($setup.goToMessage($setup.shownPin.messageId)), ["stop"]))
                    }, [
                      _hoisted_24,
                      _createTextVNode(_toDisplayString($setup.plainChatText($setup.shownPin.text)), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_23),
                    ($setup.backendStore.showAdminUi)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "nge-chat-pin-x",
                          disabled: $setup.pinBusy,
                          title: "Unpin for everyone",
                          onClick: _cache[9] || (_cache[9] = _withModifiers($event => ($setup.togglePin(null)), ["stop"]))
                        }, "Unpin", 8 /* PROPS */, _hoisted_25))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-chat-pin-x",
                      title: "Hide this pin for me",
                      "aria-label": "Hide this pin for me",
                      onClick: _withModifiers($setup.hidePin, ["stop"])
                    }, "×", 8 /* PROPS */, _hoisted_26)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                ($setup.tipsOpen)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "nge-chat-tips",
                      role: "dialog",
                      "aria-label": "Chat tips",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("button", {
                          type: "button",
                          class: "nge-chat-tips-x",
                          title: "Close (Esc)",
                          "aria-label": "Close chat tips",
                          onClick: _cache[10] || (_cache[10] = $event => ($setup.tipsOpen = false))
                        }, "×")
                      ]),
                      _hoisted_31
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: "nge-chat-messages",
                  ref: "scrollContainer",
                  onScroll: $setup.handleScroll,
                  onWheelPassive: $setup.markScrolling
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    ($setup.isLoggedIn && $setup.chatMessages.length && !$setup.searchOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          ($setup.chatStore.hasMoreHistory)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "nge-chat-history-btn",
                                disabled: $setup.chatStore.loadingHistory,
                                onClick: _cache[12] || (_cache[12] = $event => ($setup.chatStore.loadOlder()))
                              }, _toDisplayString($setup.chatStore.loadingHistory ? 'Loading…' : 'Load earlier messages'), 9 /* TEXT, PROPS */, _hoisted_34))
                            : (_openBlock(), _createElementBlock("span", _hoisted_35, "Beginning of chat"))
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.searchOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          (!$setup.chatQuery)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Type to search the last 14 days. Use -word to leave messages out, \"two words\" for a phrase, from:name for one player, and on:10/8 or after:yesterday for a day.")
                              ], 64 /* STABLE_FRAGMENT */))
                            : ($setup.chatQuery.badDate)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("That day could not be read: \"" + _toDisplayString($setup.chatQuery.badDate) + "\". Try today, yesterday, 10/8 or 2026-10-08.", 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : ($setup.searchingBack)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString($setup.searchHits.length ? $setup.searchHits.length.toLocaleString() + ' so far. ' : '') + "Looking back through the last 14 days…", 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (!$setup.searchHits.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode("No messages match in the last 14 days.")
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString($setup.searchHits.length.toLocaleString()) + " " + _toDisplayString($setup.searchHits.length === 1 ? 'message' : 'messages') + " in the last 14 days. Click one to see it in the conversation.", 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listedMessages, (msg, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: msg.id ?? ('i' + i)
                      }, [
                        (msg === $setup.firstNewMsg)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
                          : _createCommentVNode("v-if", true),
                        (msg.type === 'time')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("span", null, _toDisplayString(msg.time), 1 /* TEXT */)
                            ]))
                          : ($setup.isPinRow(msg))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(["nge-chat-sys nge-chat-pin-line", { 'nge-chat-fresh': $setup.isFresh(msg) }])
                              }, [
                                _hoisted_41,
                                _createTextVNode(),
                                _createElementVNode("b", null, _toDisplayString($setup.shortName(msg.name)), 1 /* TEXT */),
                                _createTextVNode(" " + _toDisplayString($setup.pinRowSays(msg)), 1 /* TEXT */)
                              ], 2 /* CLASS */))
                            : (msg.type === 'join' || msg.type === 'leave' || msg.type === 'disconnected' || msg.type === 'complete')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  class: _normalizeClass(["nge-chat-sys", { 'nge-chat-sys--warn': msg.type === 'disconnected', 'nge-chat-fresh': $setup.isFresh(msg) }])
                                }, _toDisplayString(msg.type === 'join' ? '→' : msg.type === 'leave' ? '←' : msg.type === 'complete' ? '✓' : '⚠') + " " + _toDisplayString(msg.parts[0]?.text || ''), 3 /* TEXT, CLASS */))
                              : ($setup.foldedAchievements.has(msg))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createCommentVNode(" An achievement line folded into the newer one that follows it. ")
                                  ], 64 /* STABLE_FRAGMENT */))
                                : ($setup.achievementOf(msg))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                      _createCommentVNode(" \"Nseraf earned Altimeter\": click to see their Trophy Case. "),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["nge-chat-sys nge-chat-ach", ['nge-chat-ach--' + $setup.achTrack(msg), { 'nge-chat-fresh': $setup.isFresh(msg) }]]),
                                        role: "button",
                                        tabindex: "0",
                                        title: 'See the achievements of ' + msg.name,
                                        onClick: $event => ($setup.openAchievement(msg)),
                                        onKeydown: _withKeys($event => ($setup.openAchievement(msg)), ["enter"])
                                      }, [
                                        ($setup.achArt(msg))
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              class: "nge-chat-ach-art",
                                              src: $setup.achArt(msg),
                                              alt: ""
                                            }, null, 8 /* PROPS */, _hoisted_43))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_44, "★")),
                                        _createElementVNode("span", null, [
                                          _createElementVNode("b", null, _toDisplayString($setup.shortName(msg.name)), 1 /* TEXT */),
                                          _createTextVNode(" earned "),
                                          _createElementVNode("b", _hoisted_45, _toDisplayString($setup.achievementOf(msg)?.name), 1 /* TEXT */),
                                          _createTextVNode(),
                                          _createElementVNode("span", _hoisted_46, _toDisplayString($setup.achWhy(msg)), 1 /* TEXT */)
                                        ])
                                      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_42)
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                  : ($setup.isAccessLine(msg))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                        _createCommentVNode(" \"Nseraf now has edit access to MEC\": said when they next come in. "),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["nge-chat-sys nge-chat-ach nge-chat-ach--access", { 'nge-chat-fresh': $setup.isFresh(msg) }])
                                        }, [
                                          _createElementVNode("img", {
                                            class: "nge-chat-ach-art",
                                            src: $setup.ACCESS_LINE_ART,
                                            alt: ""
                                          }),
                                          _createElementVNode("span", null, [
                                            _createElementVNode("b", null, _toDisplayString($setup.shortName(msg.name)), 1 /* TEXT */),
                                            _createTextVNode(" " + _toDisplayString(msg.parts.map(p => p.text || '').join('')), 1 /* TEXT */)
                                          ])
                                        ], 2 /* CLASS */)
                                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                    : ($setup.meAction(msg))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                          _createCommentVNode(" /me: \"Nseraf claps hands\", a quiet grey line. "),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["nge-chat-sys nge-chat-me", { 'nge-chat-fresh': $setup.isFresh(msg) }]),
                                            "data-msg-id": msg.id != null ? String(msg.id) : undefined
                                          }, [
                                            _createElementVNode("b", null, _toDisplayString($setup.shortName(msg.name)), 1 /* TEXT */),
                                            _createTextVNode(" " + _toDisplayString($setup.meAction(msg)), 1 /* TEXT */)
                                          ], 10 /* CLASS, PROPS */, _hoisted_47)
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                      : (msg.type === 'message' && msg.notificationId)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                            _createCommentVNode(" Announcement: carries a notification id, so the whole\n                     message opens that notification instead of telling the\n                     reader to go and look for it. "),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["nge-chat-msg nge-chat-announce", { 'nge-chat-fresh': $setup.isFresh(msg), 'nge-chat-recent': $setup.recentMsgs.has(msg) }]),
                                              role: "button",
                                              tabindex: "0",
                                              onClick: $event => ($setup.openAnnouncement(msg.notificationId)),
                                              onKeydown: _withKeys($event => ($setup.openAnnouncement(msg.notificationId)), ["enter"]),
                                              title: "Open this notification"
                                            }, [
                                              _createCommentVNode(" With a picture the time is left out, so the picture\n                       sits at the left edge (Ames 2026-10-11). "),
                                              (!$setup.announcePicture(msg.notificationId))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString($setup.msgTime(msg.dateTime)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                              ($setup.announcePicture(msg.notificationId))
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    class: "nge-chat-announce-thumb",
                                                    src: $setup.announcePicture(msg.notificationId),
                                                    alt: "",
                                                    loading: "lazy"
                                                  }, null, 8 /* PROPS */, _hoisted_50))
                                                : _createCommentVNode("v-if", true),
                                              _createCommentVNode(" 📢 only where there is no picture to mark it (Ames 2026-10-24). "),
                                              (!$setup.announcePicture(msg.notificationId))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, "📢"))
                                                : _createCommentVNode("v-if", true),
                                              _createElementVNode("span", _hoisted_52, _toDisplayString($setup.announceText(msg)), 1 /* TEXT */),
                                              _createCommentVNode(" Announcements take reactions like any message (Ames\n                       2026-10-07). The picker sits in the row, beside Open,\n                       and a click on it never opens the notification. "),
                                              (msg.id != null && $setup.isLoggedIn)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 3,
                                                    class: "nge-chat-react-add nge-chat-react-add--inline",
                                                    onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                                                    onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                                                  }, [
                                                    _createElementVNode("button", {
                                                      class: _normalizeClass(["nge-chat-react-plus", { 'nge-chat-react-plus--open': $setup.pickerFor === String(msg.id) }]),
                                                      onClick: _withModifiers($event => ($setup.togglePicker(String(msg.id), $event)), ["stop"]),
                                                      title: "React"
                                                    }, "☺+", 10 /* CLASS, PROPS */, _hoisted_53),
                                                    ($setup.pickerFor === String(msg.id))
                                                      ? (_openBlock(), _createElementBlock("span", {
                                                          key: 0,
                                                          class: "nge-chat-react-picker nge-chat-react-picker--placed",
                                                          style: _normalizeStyle($setup.inlinePickerPlace)
                                                        }, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CHAT_REACTION_QUICK, (e) => {
                                                            return (_openBlock(), _createElementBlock("button", {
                                                              key: e,
                                                              title: e === $setup.CHAT_REACTION_GEM ? 'Pyr gem' : undefined,
                                                              onClick: _withModifiers($event => ($setup.react(String(msg.id), e)), ["stop"])
                                                            }, [
                                                              (e === $setup.CHAT_REACTION_GEM)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: $setup.pyrGemUrl,
                                                                    class: "nge-chat-gem",
                                                                    alt: "Pyr gem"
                                                                  }, null, 8 /* PROPS */, _hoisted_55))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createTextVNode(_toDisplayString(e), 1 /* TEXT */)
                                                                  ], 64 /* STABLE_FRAGMENT */))
                                                            ], 8 /* PROPS */, _hoisted_54))
                                                          }), 128 /* KEYED_FRAGMENT */)),
                                                          _createElementVNode("button", {
                                                            class: _normalizeClass(["nge-chat-react-more-btn", { 'nge-chat-react-more-btn--open': $setup.pickerMore }]),
                                                            "aria-expanded": $setup.pickerMore,
                                                            title: "More reactions",
                                                            onClick: _cache[13] || (_cache[13] = _withModifiers($event => ($setup.toggleMore($event)), ["stop"]))
                                                          }, "+", 10 /* CLASS, PROPS */, _hoisted_56)
                                                        ], 4 /* STYLE */))
                                                      : _createCommentVNode("v-if", true)
                                                  ], 32 /* HYDRATE_EVENTS */))
                                                : _createCommentVNode("v-if", true),
                                              _hoisted_57,
                                              _createElementVNode("button", {
                                                class: "nge-chat-announce-hide",
                                                title: "Hide this from your chat (it stays in your notifications)",
                                                "aria-label": "Hide this announcement",
                                                onClick: _withModifiers($event => ($setup.hideAnnouncement(msg.notificationId)), ["stop"]),
                                                onKeydown: _cache[16] || (_cache[16] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                                              }, "×", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_58),
                                              (msg.id != null && Object.keys($setup.reactionsOf(msg)).length)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 4,
                                                    class: "nge-chat-react-row nge-chat-react-row--announce",
                                                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                                                  }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reactionsOf(msg), (list, emo) => {
                                                      return (_openBlock(), _createElementBlock("button", {
                                                        key: emo,
                                                        class: _normalizeClass(["nge-chat-react", { 'nge-chat-react--mine': $setup.reactedByMe(list) }]),
                                                        title: list.map(r => r.name).join(', '),
                                                        disabled: !$setup.isLoggedIn,
                                                        onClick: _withModifiers($event => ($setup.react(String(msg.id), String(emo))), ["stop"])
                                                      }, [
                                                        (emo === $setup.CHAT_REACTION_GEM)
                                                          ? (_openBlock(), _createElementBlock("img", {
                                                              key: 0,
                                                              src: $setup.pyrGemUrl,
                                                              class: "nge-chat-gem",
                                                              alt: "Pyr gem"
                                                            }, null, 8 /* PROPS */, _hoisted_60))
                                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                              _createTextVNode(_toDisplayString(emo), 1 /* TEXT */)
                                                            ], 64 /* STABLE_FRAGMENT */)),
                                                        _createElementVNode("span", null, _toDisplayString(list.length), 1 /* TEXT */)
                                                      ], 10 /* CLASS, PROPS */, _hoisted_59))
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                  ]))
                                                : _createCommentVNode("v-if", true)
                                            ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_48)
                                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                        : (msg.type === 'message' && msg.daily)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                              _createCommentVNode(" Nurro's daily leaders, as a card (Ames 2026-09-29). "),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["nge-chat-msg nge-chat-daily", { 'nge-chat-fresh': $setup.isFresh(msg), 'nge-chat-recent': $setup.recentMsgs.has(msg) }])
                                              }, [
                                                _createElementVNode("div", _hoisted_61, [
                                                  _createElementVNode("img", {
                                                    src: $setup.nurroAvatar,
                                                    alt: "",
                                                    class: "nge-chat-daily-nurro"
                                                  }, null, 8 /* PROPS */, _hoisted_62),
                                                  _hoisted_63,
                                                  _hoisted_64
                                                ]),
                                                (msg.daily.edits.length || msg.daily.cells.length)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                      (msg.daily.edits.length)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                            _hoisted_67,
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.daily.edits, (r, ri) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                key: 'e' + ri,
                                                                class: "nge-chat-daily-row"
                                                              }, [
                                                                _createElementVNode("span", _hoisted_68, _toDisplayString($setup.DAILY_MEDALS[ri]), 1 /* TEXT */),
                                                                _createElementVNode("span", {
                                                                  class: "nge-chat-daily-name",
                                                                  role: "button",
                                                                  onClick: $event => ($setup.openUserProfile(r.name)),
                                                                  title: 'View ' + r.name + '\'s profile'
                                                                }, _toDisplayString(r.name), 9 /* TEXT, PROPS */, _hoisted_69),
                                                                _createElementVNode("span", _hoisted_70, _toDisplayString(r.n), 1 /* TEXT */)
                                                              ]))
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                          ]))
                                                        : _createCommentVNode("v-if", true),
                                                      (msg.daily.cells.length)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                            _hoisted_72,
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.daily.cells, (r, ri) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                key: 'c' + ri,
                                                                class: "nge-chat-daily-row"
                                                              }, [
                                                                _createElementVNode("span", _hoisted_73, _toDisplayString($setup.DAILY_MEDALS[ri]), 1 /* TEXT */),
                                                                _createElementVNode("span", {
                                                                  class: "nge-chat-daily-name",
                                                                  role: "button",
                                                                  onClick: $event => ($setup.openUserProfile(r.name)),
                                                                  title: 'View ' + r.name + '\'s profile'
                                                                }, _toDisplayString(r.name), 9 /* TEXT, PROPS */, _hoisted_74),
                                                                _createElementVNode("span", _hoisted_75, _toDisplayString(r.n), 1 /* TEXT */)
                                                              ]))
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                          ]))
                                                        : _createCommentVNode("v-if", true)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_76, "No edits in the last 24 hours yet. The top spot is wide open!"))
                                              ], 2 /* CLASS */)
                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                          : (msg.type === 'message')
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 10,
                                                class: _normalizeClass(["nge-chat-msg", { 'nge-chat-fresh': $setup.isFresh(msg), 'nge-chat-recent': $setup.recentMsgs.has(msg), 'nge-chat-private': msg.private, 'nge-chat-msg--flash': msg.id != null && $setup.flashedMsgId === String(msg.id), 'nge-chat-msg--mine': $setup.isMine(msg), 'nge-chat-msg--hit': !!$setup.chatQuery, 'nge-chat-msg--help': !!$setup.helpLead(msg) }]),
                                                onClick: $event => ($setup.onMessageClick(msg, $event)),
                                                "data-msg-id": msg.id != null ? String(msg.id) : undefined,
                                                title: msg.private ? 'Only you can see this' : undefined
                                              }, [
                                                _createCommentVNode(" A reply: the message it answers, quoted above it. "),
                                                (msg.replyTo && $setup.repliedMsg(msg))
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: "nge-chat-quote",
                                                      onClick: _withModifiers($event => ($setup.goToMessage(msg.replyTo)), ["stop"]),
                                                      title: "Go to the message this replies to"
                                                    }, [
                                                      _hoisted_79,
                                                      _createElementVNode("span", _hoisted_80, _toDisplayString($setup.shortName($setup.repliedMsg(msg)?.name || '')), 1 /* TEXT */),
                                                      _createElementVNode("span", _hoisted_81, _toDisplayString($setup.excerptOf($setup.repliedMsg(msg))), 1 /* TEXT */)
                                                    ], 8 /* PROPS */, _hoisted_78))
                                                  : (msg.replyTo)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_82, _hoisted_85))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("span", _hoisted_86, _toDisplayString($setup.chatQuery ? $setup.msgDateTime(msg.dateTime) : $setup.msgTime(msg.dateTime)), 1 /* TEXT */),
                                                ($setup.medalFor(msg))
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 2,
                                                      class: "nge-chat-msg-trophy",
                                                      title: $setup.medalFor(msg)?.why
                                                    }, _toDisplayString($setup.medalFor(msg)?.medal), 9 /* TEXT, PROPS */, _hoisted_87))
                                                  : _createCommentVNode("v-if", true),
                                                (msg.rank === 'bot' && msg.name === 'Nurro')
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 3,
                                                      class: "nge-chat-msg-name nge-chat-nurro-name",
                                                      onClick: $setup.openNurroProfile,
                                                      title: "Nurro's profile"
                                                    }, [
                                                      _createElementVNode("img", {
                                                        src: $setup.nurroAvatar,
                                                        alt: ""
                                                      }, null, 8 /* PROPS */, _hoisted_88),
                                                      _createTextVNode("Nurro"),
                                                      _hoisted_89
                                                    ]))
                                                  : (msg.rank === 'bot')
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 4,
                                                        class: "nge-chat-msg-name nge-chat-bot-name",
                                                        title: 'nkem_test: the original EyeWire chat bot, by @nkem (2013). Say \'for science\' and it answers.'
                                                      }, [
                                                        _createTextVNode("nkem_test"),
                                                        _hoisted_91
                                                      ], 8 /* PROPS */, _hoisted_90))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                        ($setup.helpLead(msg))
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString($setup.helpLead(msg)), 1 /* TEXT */))
                                                          : _createCommentVNode("v-if", true),
                                                        _createElementVNode("span", {
                                                          class: "nge-chat-msg-name nge-chat-msg-name--clickable",
                                                          style: _normalizeStyle({ color: $setup.nameColor(msg) }),
                                                          onClick: $event => ($setup.openUserProfile(msg.name)),
                                                          title: 'View ' + msg.name + '\'s profile'
                                                        }, _toDisplayString($setup.shortName(msg.name)), 13 /* TEXT, STYLE, PROPS */, _hoisted_93)
                                                      ], 64 /* STABLE_FRAGMENT */)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.parts, (part, pi) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                                    (part.type === 'sender')
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64 /* STABLE_FRAGMENT */))
                                                      : (part.type === 'link' && $setup.isViewLink(part.text))
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 1,
                                                            class: "nge-chat-view-chip",
                                                            href: part.text,
                                                            target: "_blank",
                                                            rel: "noopener",
                                                            title: "Open this view in a new tab"
                                                          }, "📍 Open view", 8 /* PROPS */, _hoisted_94))
                                                        : (part.type === 'link' && $setup.isShotLink(part.text))
                                                          ? (_openBlock(), _createElementBlock("a", {
                                                              key: 2,
                                                              href: part.text,
                                                              target: "_blank",
                                                              rel: "noopener",
                                                              class: "nge-chat-shot",
                                                              title: "Open the screenshot full size"
                                                            }, [
                                                              _createElementVNode("img", {
                                                                src: part.text,
                                                                alt: "Screenshot",
                                                                loading: "lazy"
                                                              }, null, 8 /* PROPS */, _hoisted_96)
                                                            ], 8 /* PROPS */, _hoisted_95))
                                                          : (part.type === 'link')
                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                key: 3,
                                                                href: part.text,
                                                                target: "_blank",
                                                                rel: "noopener",
                                                                class: "nge-chat-link"
                                                              }, _toDisplayString(part.text), 9 /* TEXT, PROPS */, _hoisted_97))
                                                            : (part.type === 'mention')
                                                              ? (_openBlock(), _createElementBlock("span", {
                                                                  key: 4,
                                                                  class: _normalizeClass(["nge-chat-mention", { 'nge-chat-mention--me': $setup.isSelfMention(part.text) }]),
                                                                  role: "button",
                                                                  tabindex: "0",
                                                                  onClick: $event => ($setup.openUserProfile(part.text.slice(1))),
                                                                  onKeydown: _withKeys($event => ($setup.openUserProfile(part.text.slice(1))), ["enter"]),
                                                                  title: 'Open ' + part.text.slice(1) + '’s profile'
                                                                }, _toDisplayString(part.text), 43 /* TEXT, CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_98))
                                                              : (part.type === 'segment')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_99, [
                                                                    _createElementVNode("a", {
                                                                      class: "nge-chat-seg-link",
                                                                      href: $setup.cellLinkHref(part.text, msg.dataset),
                                                                      onClick: $event => ($setup.onSegLinkClick($event, part.text, msg.dataset)),
                                                                      title: 'Jump to segment ' + part.text.slice(1) + (msg.dataset ? ' in ' + msg.dataset : '') + '. Right click or middle click to open it in a new tab.'
                                                                    }, _toDisplayString(part.text), 9 /* TEXT, PROPS */, _hoisted_100),
                                                                    _createElementVNode("span", {
                                                                      class: "nge-chat-seg-ds",
                                                                      title: msg.dataset || 'Sent before the dataset was recorded'
                                                                    }, _toDisplayString($setup.datasetLabel(msg.dataset)), 9 /* TEXT, PROPS */, _hoisted_101),
                                                                    _createElementVNode("button", {
                                                                      class: "nge-chat-seg-copy",
                                                                      onClick: $event => ($setup.copySegId(part.text, $event)),
                                                                      title: 'Copy ' + part.text.slice(1)
                                                                    }, _toDisplayString($setup.copiedSegId === part.text.slice(1) ? '✓' : '⧉'), 9 /* TEXT, PROPS */, _hoisted_102)
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("span", {
                                                                    key: 6,
                                                                    class: _normalizeClass(["nge-chat-msg-text", { 'nge-chat-bot-text': msg.rank === 'bot' && msg.name !== 'Nurro' }])
                                                                  }, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.richPieces($setup.partText(msg, part)), (piece, ri) => {
                                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: ri }, [
                                                                        (piece.bold)
                                                                          ? (_openBlock(), _createElementBlock("b", {
                                                                              key: 0,
                                                                              class: _normalizeClass(["nge-chat-b", { 'nge-chat-u': piece.underline }])
                                                                            }, _toDisplayString(piece.text), 3 /* TEXT, CLASS */))
                                                                          : (piece.underline)
                                                                            ? (_openBlock(), _createElementBlock("u", _hoisted_103, _toDisplayString(piece.text), 1 /* TEXT */))
                                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                                _createTextVNode(_toDisplayString(piece.text), 1 /* TEXT */)
                                                                              ], 64 /* STABLE_FRAGMENT */))
                                                                      ], 64 /* STABLE_FRAGMENT */))
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                  ], 2 /* CLASS */))
                                                  ], 64 /* STABLE_FRAGMENT */))
                                                }), 128 /* KEYED_FRAGMENT */)),
                                                ($setup.isHelpAsk(msg))
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 6,
                                                      type: "button",
                                                      class: "nge-chat-view-chip nge-chat-join-chip",
                                                      disabled: $setup.joinOffered.has($setup.joinKey(msg)),
                                                      title: $setup.joinOffered.has($setup.joinKey(msg)) ? 'Offer sent. Waiting for them to accept.' : `Offer to join ${msg.name}'s view and help, live. They choose whether to accept.`,
                                                      onClick: $event => ($setup.joinHelp(msg))
                                                    }, _toDisplayString($setup.joinOffered.has($setup.joinKey(msg)) ? '🤝 Offered' : '🤝 Join'), 9 /* TEXT, PROPS */, _hoisted_104))
                                                  : _createCommentVNode("v-if", true),
                                                (msg.botLanguage)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(msg.botLanguage), 1 /* TEXT */))
                                                  : _createCommentVNode("v-if", true),
                                                ($setup.SHOW_CHAT_DELETE && msg.id != null && ($setup.backendStore.showAdminUi || (msg.userId && msg.userId === $setup.backendStore.userId)))
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 8,
                                                      class: "nge-chat-del",
                                                      title: msg.userId === $setup.backendStore.userId ? 'Delete your message' : 'Delete this message for everyone (admin)',
                                                      onClick: _withModifiers($event => ($setup.deleteChatMessage(msg)), ["stop"])
                                                    }, "🗑", 8 /* PROPS */, _hoisted_106))
                                                  : _createCommentVNode("v-if", true),
                                                (msg.id != null && $setup.isLoggedIn)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                                      _createElementVNode("span", _hoisted_107, [
                                                        (msg.rank !== 'bot' && !msg.notificationId)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 0,
                                                              class: "nge-chat-react-plus nge-chat-reply-btn",
                                                              onClick: _withModifiers($event => ($setup.startReply(msg)), ["stop"]),
                                                              title: "Reply"
                                                            }, "↩", 8 /* PROPS */, _hoisted_108))
                                                          : _createCommentVNode("v-if", true),
                                                        _createElementVNode("button", {
                                                          class: _normalizeClass(["nge-chat-react-plus", { 'nge-chat-react-plus--open': $setup.pickerFor === String(msg.id) || $setup.pinMenuFor === String(msg.id) }]),
                                                          onClick: _withModifiers($event => ($setup.togglePicker(String(msg.id), $event)), ["stop"]),
                                                          onContextmenu: $event => ($setup.openPinMenu(msg, $event)),
                                                          "data-nge-own-menu": $setup.canPin(msg) ? '' : undefined,
                                                          title: $setup.canPin(msg) ? 'React. Right click to pin this message.' : 'React'
                                                        }, "☺+", 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_109),
                                                        ($setup.pickerFor === String(msg.id))
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 1,
                                                              class: "nge-chat-react-picker nge-chat-react-picker--placed",
                                                              style: _normalizeStyle($setup.inlinePickerPlace)
                                                            }, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CHAT_REACTION_QUICK, (e) => {
                                                                return (_openBlock(), _createElementBlock("button", {
                                                                  key: e,
                                                                  title: e === $setup.CHAT_REACTION_GEM ? 'Pyr gem' : undefined,
                                                                  onClick: _withModifiers($event => ($setup.react(String(msg.id), e)), ["stop"])
                                                                }, [
                                                                  (e === $setup.CHAT_REACTION_GEM)
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 0,
                                                                        src: $setup.pyrGemUrl,
                                                                        class: "nge-chat-gem",
                                                                        alt: "Pyr gem"
                                                                      }, null, 8 /* PROPS */, _hoisted_111))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _createTextVNode(_toDisplayString(e), 1 /* TEXT */)
                                                                      ], 64 /* STABLE_FRAGMENT */))
                                                                ], 8 /* PROPS */, _hoisted_110))
                                                              }), 128 /* KEYED_FRAGMENT */)),
                                                              _createElementVNode("button", {
                                                                class: _normalizeClass(["nge-chat-react-more-btn", { 'nge-chat-react-more-btn--open': $setup.pickerMore }]),
                                                                "aria-expanded": $setup.pickerMore,
                                                                title: "More reactions",
                                                                onClick: _cache[18] || (_cache[18] = _withModifiers($event => ($setup.toggleMore($event)), ["stop"]))
                                                              }, "+", 10 /* CLASS, PROPS */, _hoisted_112)
                                                            ], 4 /* STYLE */))
                                                          : _createCommentVNode("v-if", true),
                                                        _createCommentVNode(" Admins: a right click on React offers the pin (Ames 2026-10-10:\n                           no pin button on every message). "),
                                                        ($setup.pinMenuFor === String(msg.id))
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                                                              _createElementVNode("button", {
                                                                type: "button",
                                                                role: "menuitem",
                                                                disabled: $setup.pinBusy,
                                                                onClick: _withModifiers($event => ($setup.pinFromMenu(msg)), ["stop"])
                                                              }, "📌 " + _toDisplayString($setup.isPinnedMsg(msg) ? 'Unpin for everyone' : 'Pin for everyone'), 9 /* TEXT, PROPS */, _hoisted_114)
                                                            ]))
                                                          : _createCommentVNode("v-if", true)
                                                      ]),
                                                      (Object.keys($setup.reactionsOf(msg)).length)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reactionsOf(msg), (list, emo) => {
                                                              return (_openBlock(), _createElementBlock("button", {
                                                                key: emo,
                                                                class: _normalizeClass(["nge-chat-react", { 'nge-chat-react--mine': $setup.reactedByMe(list) }]),
                                                                title: list.map(r => r.name).join(', '),
                                                                onClick: _withModifiers($event => ($setup.react(String(msg.id), String(emo))), ["stop"])
                                                              }, [
                                                                (emo === $setup.CHAT_REACTION_GEM)
                                                                  ? (_openBlock(), _createElementBlock("img", {
                                                                      key: 0,
                                                                      src: $setup.pyrGemUrl,
                                                                      class: "nge-chat-gem",
                                                                      alt: "Pyr gem"
                                                                    }, null, 8 /* PROPS */, _hoisted_117))
                                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                      _createTextVNode(_toDisplayString(emo), 1 /* TEXT */)
                                                                    ], 64 /* STABLE_FRAGMENT */)),
                                                                _createElementVNode("span", null, _toDisplayString(list.length), 1 /* TEXT */)
                                                              ], 10 /* CLASS, PROPS */, _hoisted_116))
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                          ]))
                                                        : _createCommentVNode("v-if", true)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                  : _createCommentVNode("v-if", true)
                                              ], 10 /* CLASS, PROPS */, _hoisted_77))
                                            : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (!$setup.isLoggedIn)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, " Log in to chat "))
                      : ($setup.chatMessages.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_119, " Say hello! "))
                        : _createCommentVNode("v-if", true)
                  ])
                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)
              ]),
              _createCommentVNode(" New messages banner "),
              _createVNode(_Transition, { name: "nge-chat-banner" }, {
                default: _withCtx(() => [
                  ($setup.isScrolledUp && $setup.unreadMessages)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "nge-chat-new-banner",
                        onClick: $setup.scrollToBottom
                      }, " ↓ new "))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createCommentVNode(" Cross-dataset jump guard: a root ID from another segmentation would\n             land on a different cell (or nothing) without warning. "),
              ($setup.pendingSegJump)
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    _createCommentVNode(" A cell ID only exists in its own dataset, so there is nothing to\n               hedge about: say where it is, and offer to go there (Ames\n               2026-10-10). When the message carries no dataset, say that. "),
                    _createElementVNode("div", _hoisted_121, [
                      ($setup.pendingSegJump.from)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("This cell is in "),
                            _createElementVNode("strong", null, _toDisplayString($setup.pendingSegJump.from), 1 /* TEXT */),
                            _createTextVNode(". You're viewing "),
                            _createElementVNode("strong", null, _toDisplayString($setup.pendingSegJump.to), 1 /* TEXT */),
                            _createTextVNode(".")
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("This message does not say which dataset the cell is in. You're viewing "),
                            _createElementVNode("strong", null, _toDisplayString($setup.pendingSegJump.to), 1 /* TEXT */),
                            _createTextVNode(".")
                          ], 64 /* STABLE_FRAGMENT */))
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("button", {
                        class: "nge-chat-segwarn-go",
                        onClick: $setup.confirmSegJump
                      }, _toDisplayString($setup.pendingSegJump.from ? `Jump to ${$setup.pendingSegJump.from}` : 'Look for it here'), 1 /* TEXT */),
                      _createElementVNode("button", {
                        class: "nge-chat-segwarn-no",
                        onClick: _cache[19] || (_cache[19] = $event => ($setup.pendingSegJump = null))
                      }, "Cancel")
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Input "),
              _createElementVNode("div", _hoisted_123, [
                ($setup.replyingTo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                      _hoisted_125,
                      _createElementVNode("span", _hoisted_126, [
                        _createTextVNode("Replying to "),
                        _createElementVNode("b", null, _toDisplayString($setup.shortName($setup.replyingTo.name)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_127, _toDisplayString($setup.excerptOf($setup.replyingTo, 48)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("button", {
                        class: "nge-chat-replying-x",
                        onClick: _cache[20] || (_cache[20] = $event => ($setup.replyingTo = null)),
                        title: "Cancel the reply",
                        "aria-label": "Cancel the reply"
                      }, "×")
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.mentionOptions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mentionOptions, (o, oi) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: o.handle,
                          class: _normalizeClass(["nge-chat-mention-opt", { 'nge-chat-mention-opt--active': oi === $setup.mentionIndex }]),
                          role: "option",
                          onMousedown: _withModifiers($event => ($setup.pickMention(o.handle)), ["prevent"]),
                          onMouseenter: $event => ($setup.mentionIndex = oi)
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["nge-chat-mention-dot", { 'nge-chat-mention-dot--on': o.online }])
                          }, null, 2 /* CLASS */),
                          _createTextVNode("@" + _toDisplayString(o.handle), 1 /* TEXT */)
                        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_129))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.joinNote)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString($setup.joinNote), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.shareError)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "nge-chat-share-error",
                      onClick: _cache[21] || (_cache[21] = $event => ($setup.shareError = ''))
                    }, _toDisplayString($setup.shareError), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.pendingView && !$setup.searchOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                      _createElementVNode("span", _hoisted_132, [
                        _createTextVNode("📍 My view"),
                        ($setup.pendingView.shotUrl)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" + 📷")
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "nge-chat-pending-x",
                          title: "Remove the view",
                          "aria-label": "Remove the view",
                          onClick: _cache[22] || (_cache[22] = _withModifiers($event => ($setup.pendingView = null), ["stop"]))
                        }, "×")
                      ]),
                      _hoisted_133
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.searchOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                      _hoisted_135,
                      _withDirectives(_createElementVNode("input", {
                        ref: "searchEl",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($setup.searchText) = $event)),
                        type: "text",
                        class: "nge-chat-input nge-chat-search-input",
                        placeholder: "Search chat",
                        "aria-label": "Search chat",
                        autocomplete: "off",
                        spellcheck: "false",
                        onKeydown: _withModifiers($setup.onSearchKeydown, ["stop"]),
                        onKeyup: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"])),
                        onKeypress: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_136), [
                        [_vModelText, $setup.searchText]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-chat-share-btn nge-chat-search-x",
                        title: "Close search (Esc)",
                        "aria-label": "Close search",
                        onClick: _withModifiers($setup.closeSearch, ["stop"])
                      }, "×", 8 /* PROPS */, _hoisted_137)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_138, [
                      _createElementVNode("span", _hoisted_139, [
                        _createElementVNode("button", {
                          class: "nge-chat-share-btn",
                          disabled: !$setup.isLoggedIn || !$setup.chatUsable || $setup.sharing,
                          onClick: _cache[26] || (_cache[26] = _withModifiers($event => ($setup.shareMenuOpen = !$setup.shareMenuOpen), ["stop"])),
                          title: "Share my view in chat"
                        }, [
                          ($setup.sharing)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("…")
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_141, _hoisted_143))
                        ], 8 /* PROPS */, _hoisted_140),
                        ($setup.shareMenuOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_144, [
                              _createElementVNode("button", {
                                onClick: _cache[27] || (_cache[27] = $event => ($setup.shareView(false)))
                              }, "📍 Share my view"),
                              _createElementVNode("button", {
                                onClick: _cache[28] || (_cache[28] = $event => ($setup.shareView(true)))
                              }, "📷 Share view + screenshot")
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        ref: "inputEl",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => (($setup.messageInput) = $event)),
                        class: _normalizeClass(["nge-chat-input", { 'nge-chat-input--over': $setup.messageTooLong }]),
                        rows: "1",
                        placeholder: !$setup.isLoggedIn ? 'Log in to chat' : $setup.isQuiet ? '>' : !$setup.chatUsable ? 'Chat is connecting…' : 'Message... (@ to mention)',
                        title: "Enter sends. *bold* and _underline_, or Ctrl+B and Ctrl+U on selected text.",
                        onKeydown: _withModifiers($setup.onInputKeydown, ["stop"]),
                        onKeyup: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"])),
                        onKeypress: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"])),
                        onBeforeinput: $setup.onBeforeInput,
                        enterkeyhint: "send",
                        onInput: $setup.onInputChange,
                        onClick: $setup.onInputChange,
                        onBlur: _cache[32] || (_cache[32] = $event => ($setup.mentionQuery = null)),
                        spellcheck: "true",
                        autocomplete: "off",
                        disabled: !$setup.isLoggedIn || !$setup.chatUsable
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_145), [
                        [_vModelText, $setup.messageInput]
                      ]),
                      ($setup.showLengthCount)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["nge-chat-count", { 'nge-chat-count--over': $setup.messageTooLong }]),
                            title: `Up to ${$setup.CHAT_MAX_CHARS} characters, links don't count`
                          }, _toDisplayString($setup.CHAT_MAX_CHARS - $setup.messageLength), 11 /* TEXT, CLASS, PROPS */, _hoisted_146))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", _hoisted_147, [
                        _createElementVNode("button", {
                          class: "nge-chat-share-btn nge-chat-emoji-btn",
                          disabled: !$setup.isLoggedIn || !$setup.chatUsable,
                          onMousedown: _cache[33] || (_cache[33] = _withModifiers(() => {}, ["prevent"])),
                          onClick: _cache[34] || (_cache[34] = _withModifiers($event => ($setup.toggleEmoji($event)), ["stop"])),
                          title: "Add an emoji"
                        }, "🙂", 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_148),
                        ($setup.emojiOpen)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "nge-chat-emoji-grid",
                              style: _normalizeStyle($setup.emojiPlace)
                            }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.CHAT_EMOJI, (e) => {
                                return _createElementVNode("button", {
                                  key: e,
                                  onMousedown: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["prevent"])),
                                  onClick: _withModifiers($event => ($setup.insertEmoji(e)), ["stop"])
                                }, _toDisplayString(e), 41 /* TEXT, PROPS, HYDRATE_EVENTS */, _hoisted_149)
                              }), 64 /* STABLE_FRAGMENT */))
                            ], 4 /* STYLE */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" The pumpkin button (Ames 2026-10-20), in season: off and on\n                 on a patch cell, a trip to the patch anywhere else. "),
                      ($setup.showPumpkinBtn)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass(["nge-chat-share-btn nge-chat-pumpkin-btn", { off: $setup.pumpkinOff() }]),
                            onMousedown: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["prevent"])),
                            onClick: _cache[37] || (_cache[37] = _withModifiers($event => ($setup.onPumpkin()), ["stop"])),
                            title: $setup.pumpkinTitle(),
                            "aria-label": $setup.pumpkinTitle()
                          }, "🎃", 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_150))
                        : _createCommentVNode("v-if", true),
                      ($setup.askPatch)
                        ? (_openBlock(), _createBlock($setup["PumpkinPatchPrompt"], {
                            key: 2,
                            onYes: _cache[38] || (_cache[38] = $event => ($setup.goToPatch())),
                            onNo: _cache[39] || (_cache[39] = $event => ($setup.askPatch = false)),
                            onSmash: _cache[40] || (_cache[40] = $event => ($setup.smashPatch())),
                            onToggle: _cache[41] || (_cache[41] = $event => ($setup.togglePatch()))
                          }))
                        : _createCommentVNode("v-if", true)
                    ]))
              ]),
              ($setup.showShareShot)
                ? (_openBlock(), _createBlock($setup["ScreenshotDialog"], {
                    key: 2,
                    show: $setup.showShareShot,
                    mode: "attach",
                    onClose: _cache[42] || (_cache[42] = $event => ($setup.showShareShot = false)),
                    onAttached: $setup.onShareShotAttached
                  }, null, 8 /* PROPS */, ["show"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */)
    ])),
    _createCommentVNode(" More reactions: drawn on the page itself, not inside the chat, so the\n       chat's own edges never cut it off however small the chat is. "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.pickerMore && $setup.pickerFor)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-chat-react-more",
            style: _normalizeStyle($setup.morePlace),
            role: "menu",
            "aria-label": "More reactions",
            onClick: _cache[43] || (_cache[43] = _withModifiers(() => {}, ["stop"])),
            onMousedown: _cache[44] || (_cache[44] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CHAT_REACTION_MORE, (e) => {
              return (_openBlock(), _createElementBlock("button", {
                key: e,
                role: "menuitem",
                onClick: _withModifiers($event => ($setup.react($setup.pickerFor, e)), ["stop"])
              }, _toDisplayString(e), 9 /* TEXT, PROPS */, _hoisted_151))
            }), 128 /* KEYED_FRAGMENT */))
          ], 36 /* STYLE, HYDRATE_EVENTS */))
        : _createCommentVNode("v-if", true)
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}